<template>
  <div class="card">
    <div class="card-body py-0">
      <div class="mt-2 py-2 clearfix">
        <div class="pull-left mt-1" v-html="$t('latest_pro_artists')">
        </div>
        <div class="pull-right" v-if="!hidebuttons">
          <router-link to="/upgrade?from=pro_artist_widget" class="btn btn-sm btn-primary mt--1">
            {{ $t('upgrade_now') }}
          </router-link>
        </div>
      </div>
      <hr class="mt-0 mb-0"/>
      <div class="card-list">
        <p class="text-center text-muted p-3" v-if="!potentialArtists.length">
          <i class="fa fa-spinner fa-spin"></i>
        </p>
        <div class="carousel-slider-artists owl-carousel">
          <div class="item-list" v-for="(artist, index) in potentialArtists" v-bind:key="`potential_${index}`">
            <a class="avatar" :href="`https://music.indiefy.net/artist/${artist.key}`" target="_blank">
              <img :src="artist.cover_image_small || artist.cover_image || '/static/img/img-placeholder-dark.jpg'" onerror="this.src = '/static/img/img-placeholder.jpg'" :alt="artist.name" class="avatar-img rounded-circle">
            </a>
            <div class="info-user ml-3">
              <div class="username">
                <img width="16" :src="`/static/img/countries/${artist.user.country || 'default'}.png`" class="mr-1"/>
                <a :href="`https://music.indiefy.net/artist/${artist.key}`" target="_blank">
                  {{ artist.name | truncate(27) }}
                </a>
              </div>
              <div class="status">{{ artist.main_genre }} <span v-if="artist.user.country">/ {{ getCountryName(artist.user.country) }}</span></div>
            </div>
            <a :href="`https://indiefy.me/${artist.key}`" target="_blank" v-if="!hidebuttons">
              <i class="fa fa-external-link-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from '../components/utils/filters'
import Public from '../services/public'
import countries from '../data/countries'
import _ from 'underscore'

export default {
  name: 'LatestPro',
  props: ['hidebuttons'],
  data: function () {
    return {
      user: {},
      potentialArtists: []
    }
  },
  methods: {
    initCarousel: function () {
      setTimeout(() => {
        window.$('.carousel-slider-artists').owlCarousel({
          autoPlay: 3000,
          navigation: false,
          slideSpeed: 500,
          pagination: false,
          paginationSpeed: 1000,
          singleItem: true,
          items: 1,
          autoHeight: true,
          addClassActive: true,
          goToFirst: true,
          goToFirstSpeed: 200
        })
      }, 500)
    },
    getCountryName: function (userCountry) {
      let country = _.find(countries, item => item.code === userCountry)

      if (country) {
        return country.name
      }

      return 'N/A'
    }
  },
  mounted: function () {
    Public.getPotentialArtists().then(response => {
      this.potentialArtists = response.data
      this.initCarousel()
    })
  },
  created: function () {
    this.user = this.$user
  },
  components: {
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/LatestPro.vue